import helpers from './methods.js'

/**
 * Global helper object
 */
for (var helper in helpers) {
    window[helper] = helpers[helper]
}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/index.js